import { Instance, types } from 'mobx-state-tree';
import { BuildStore } from './Build/BuildStore';
import { BuildsStore } from './Build/BuildsStore';


export const RootStore = types.model('RootStore', {
  buildStore: BuildStore,
  buildsStore: BuildsStore
});

export interface IRootStore extends Instance<typeof RootStore> {
}
